/**
 * Native QR / barcode scanner — implemented in react-native-ops-scanner
 * (shared with tl-app). Re-exported here so screens keep one import path.
 */
export {
  isNativeCodeScannerAvailable,
  normalizeScannerConfig,
  scanCode,
} from "react-native-ops-scanner";
export type {
  ScanMode,
  ScannerConfig,
  ScanResult,
} from "react-native-ops-scanner";
